import { render, staticRenderFns } from "./DetailModuleSkeleton.vue?vue&type=template&id=321db564&scoped=true&"
import script from "./DetailModuleSkeleton.vue?vue&type=script&lang=js&"
export * from "./DetailModuleSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./DetailModuleSkeleton.vue?vue&type=style&index=0&id=321db564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321db564",
  null
  
)

export default component.exports